<script lang="ts">
	import { format } from 'svelte-i18n';
	import type { Device } from 'src/types/Device';
	import { LabelV2 } from '@Shelly/shelly-design-system';
	import { isMockLightDevice } from 'src/helpers/dev/mock_light_ids';

	export let device: Device | undefined;
</script>

{#if isMockLightDevice(device)}
	<div class="d-flex justify-content-center mb-s">
		<LabelV2
			size="s"
			value={$format('label_mock_device', { default: 'Mock' })}
			backgroundColor="--color-warning"
			icon="fas fa-flask"
		/>
	</div>
{/if}
